/* eslint-disable prettier/prettier */
import React from "react";

const Download = () => (
  <svg
    width="32"
    height="33"
    viewBox="0 0 32 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.618 19.1867C15.6355 19.2084 15.6579 19.226 15.6835 19.2381C15.7091 19.2502 15.7372 19.2565 15.7656 19.2565C15.7941 19.2565 15.8222 19.2502 15.8477 19.2381C15.8733 19.226 15.8957 19.2084 15.9133 19.1867L18.5383 15.9614C18.6344 15.843 18.5477 15.6678 18.3906 15.6678H16.6539V7.96529C16.6539 7.86514 16.5695 7.7832 16.4664 7.7832H15.0602C14.957 7.7832 14.8727 7.86514 14.8727 7.96529V15.6655H13.1406C12.9836 15.6655 12.8969 15.8407 12.993 15.9591L15.618 19.1867ZM24.3438 18.39H22.9375C22.8344 18.39 22.75 18.472 22.75 18.5721V22.0774H8.78125V18.5721C8.78125 18.472 8.69687 18.39 8.59375 18.39H7.1875C7.08437 18.39 7 18.472 7 18.5721V23.0789C7 23.4818 7.33516 23.8072 7.75 23.8072H23.7812C24.1961 23.8072 24.5312 23.4818 24.5312 23.0789V18.5721C24.5312 18.472 24.4469 18.39 24.3438 18.39Z"
      fill="#1A1B1B"
    />
  </svg>
);

export default Download;
